var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},_vm._l((_vm.grupo.eebpm_userg),function(user){return _c('v-row',{key:user.usr_cod},[_c('v-col',{staticClass:"text-sm-left"},[_vm._v(" "+_vm._s(user.usr_name)+" ")])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }